var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "image-viewer" },
    [
      _vm.src
        ? _c(
            "el-image",
            {
              class: _vm.className,
              style: _vm.style,
              attrs: {
                src: _vm.src,
                "preview-src-list": [_vm.src],
                fit: "cover",
              },
              on: { click: _vm.handleClick },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-placeholder",
                  attrs: { slot: "placeholder" },
                  slot: "placeholder",
                },
                [_vm._v(" 加载中... ")]
              ),
              _c(
                "div",
                {
                  staticClass: "image-error",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_vm._v(" 加载失败 ")]
              ),
            ]
          )
        : _c("div", { staticClass: "image-empty" }, [_vm._v(" 暂无图片 ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }